import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {SafeZone} from '@gongxigames/framework/core/fragments/display/SafeZone/SafeZone';
import {Container} from 'pixi.js';

export const safeZoneStore = Store.createStore({
    /**
     * Root container for the slot.
     * Do not scaled, the same scale as the screen in physical pixels.
     * Scale, position, and rotation shouldn't be changed,
     * they should stay the default.
     */
    stage_rootContainer: Store.computed(() => new Container()),

    /**
     * The safe zone for the UI.
     * The scale and position is managed by `SafeZone` class
     * according to the configuration provided.
     * Shouldn't be changed in other places.
     */
    stage_safeZoneContainer_ui: Store.computed(() => new Container()),

    /**
     * The safe zone for the GAME.
     * The scale and position is managed by `SafeZone` class
     * according to the configuration provided.
     * Shouldn't be changed in other places.
     */
    stage_safeZoneContainer_game: Store.computed(() => new Container()),

    /**
     * The root container for UI.
     * All ui elements should be children's of this container.
     * This container can be used freely for different manipulations.
     * For example, it can be used for full-screen effects like shake, zoom, fade.
     */
    stage_rootContainer_ui: Store.computed(() => new Container()),

    /**
     * The root container for UI.
     * All ui elements should be children's of this container.
     * This container can be used freely for different manipulations.
     * For example, it can be used for full-screen effects like shake, zoom, fade.
     */
    stage_rootContainer_game: Store.computed(() => new Container()),

    /**
     * Handles UI autoscaling accordion to UI config and screen size.
     * Controls `stage_safeZoneContainer_ui`
     */
    stage_safeZoneState_ui: Store.signal(SafeZone.default()),

    /**
     * Handles GAME autoscaling accordion to GAME config and screen size.
     * Controls `stage_safeZoneContainer_game`
     */
    stage_safeZoneState_game: Store.signal(SafeZone.default()),
});